import { Smile, Send } from 'lucide-react';
import React, { useCallback, useRef, useState } from 'react';
import { postService } from '../../../services/post.service';
import { IReplyCommentParams } from '../../../models/post.model';
import EmojiPopover from '../../emoji-popover/emoji-popover';

interface CommentReplyInputComponentProps {
  commentId: string;
  getReplyCommentWhenReply: (any: any) => void;
  setReplyCommentId: (commentId: string) => void;
  isShowReply: boolean;
  setIsShowReply: (value: boolean) => void;
  replyToName?: string;
}

const CommentReplyInputComponent = ({
  commentId,
  getReplyCommentWhenReply,
  setReplyCommentId,
  isShowReply,
  setIsShowReply,
  replyToName,
}: CommentReplyInputComponentProps) => {
  // Prefill @Tên người được phản hồi (tag) để nhắc + dễ nhận thông báo.
  const [replyCommentValue, setReplyCommentValue] = useState<string>(
    replyToName ? `@${replyToName} ` : ''
  );
  const [showReplyEmojiPicker, setShowReplyEmojiPicker] = useState<boolean>(false);

  const handleSendRelyComment = async () => {
    //
    if (!replyCommentValue) {
      return;
    }

    setReplyCommentId(commentId);

    try {
      const payload: IReplyCommentParams = {
        content: replyCommentValue,
        replyToCommentId: commentId,
      };

      await postService.replyComment(payload);

      setIsShowReply(true);
      setReplyCommentValue('');

      if (isShowReply) {
        await getReplyCommentWhenReply(commentId);
      }

      // await refreshCommentClient();
    } catch (error) {
      //
    }
  };

  const replyEmojiBtnRef = useRef<HTMLButtonElement>(null);

  const onReplyEmojiSelect = useCallback((emoji: any) => {
    setReplyCommentValue((prev) => prev + emoji.native);
    setShowReplyEmojiPicker(false);
  }, []);

  return (
    <div className="mt-4 flex items-center gap-2">
      <div className="flex-1 relative">
        <input
          type="text"
          placeholder="Viết phản hồi..."
          className="w-full bg-gray-100 dark:bg-zinc-800 rounded-full px-4 py-2 text-sm outline-none pr-10"
          value={replyCommentValue}
          onChange={(e) => setReplyCommentValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSendRelyComment();
            }
          }}
        />
        <button
          ref={replyEmojiBtnRef}
          type="button"
          onClick={() => setShowReplyEmojiPicker(!showReplyEmojiPicker)}
          className="absolute right-3 top-1/2 -translate-y-1/2"
        >
          <Smile size={20} className="text-slate-500" />
        </button>
        <EmojiPopover
          open={showReplyEmojiPicker}
          anchorRef={replyEmojiBtnRef}
          onEmojiSelect={onReplyEmojiSelect}
          onClose={() => setShowReplyEmojiPicker(false)}
        />
      </div>
      <button
        onClick={() => handleSendRelyComment()}
        className="text-blue-500 hover:text-blue-600 disabled:opacity-50"
        disabled={!replyCommentValue}
      >
        <Send size={16} />
      </button>
    </div>
  );
};

export default CommentReplyInputComponent;
